/* istanbul ignore file */
import Head from 'next/head';
import React from 'react';

const title = 'Find a Couple: Search Zola Registries & Websites';
const description =
  "Find a couple's wedding registry or wedding website here. Zero fee gifting and easy ordering. Offering 24/7 customer support.";

function FindACoupleMeta(): JSX.Element {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />

      <link rel="canonical" href="https://www.zola.com/search/wedding-registry" />
      <meta property="og:url" content="https://www.zola.com/search/wedding-registry" />
      <meta
        property="og:image"
        content="https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/logos/zola-heart-marine.png"
      />
      <meta name="twitter:site" content="@zola" />
      <meta name="twitter:card" content="summary" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content="zola.com" />
      <meta property="ios-deep-link" content="zolaiphone://home" />
    </Head>
  );
}

export default FindACoupleMeta;
